"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./module/index"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angular2-flash-messages/index.js
// module id = ../../../../angular2-flash-messages/index.js
// module chunks = 7